import { Entry } from '../Entry'

export function Entry20220503() {
  return (
    <Entry title="03/05/2022 - v3.0.4">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12596/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
